
import Vue from 'vue'
import App from './App.vue'
import router from './routers/index.js'
import ElementUI from 'element-ui';
//引入路由
// import router from '@/router';
import store from './stores/index.js'
import './plugins/element.js'
// import './rem.js'
import 'reset-css'

import "@src/assets/icon/iconfont.css";
import "@src/assets/icon/iconfont1.css";
import '@src/assets/style/editor.css';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.config.productionTip = false
import 'element-ui/lib/theme-chalk/index.css';
import AudioVisual from 'vue-audio-visual'
// 富文本插件
import VueQuillEditor from 'vue-quill-editor';
// require styles 引入样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
Vue.use(VueQuillEditor);
Vue.use(AudioVisual);
// 图片缩放设置
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer).use(ElementUI);

// window.onbeforeunload  = function(event){
//   var event = event || window.event;
//   
//   if (event) {192.168.1.176:8466
//       event.returnValue  = "刷新页面,无法获取阿里云软电话系统?";
//   }
//   return '刷新页面,无法获取阿里云软电话系统?';
// }

// 图表格
import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts

// window.addEventListener('beforeunload', (event) => {
//     // console.log(event);
//     // Cancel the event as stated by the standard.
//   if(!/\/login\?logout\=true$/.test(event.target.URL)){
//     event.preventDefault();
//     // Chrome requires returnValue to be set.
//     event.returnValue = '刷新页面,无法获取阿里云软电话系统?';
//     return '刷新页面,无法获取阿里云软电话系统?'
//   }
// });

// 引入组件库
import VueEasytable from "vue-easytable";

import "vue-easytable/libs/theme-default/index.css";
Vue.use(VueEasytable).use(VueEasytable);

var PubSub = function(){
  this.obj = {}
}
PubSub.prototype.on = function(eventType, fn){
  if (!this.obj[eventType]) {
    this.obj[eventType] = []
  }
  this.obj[eventType].push(fn)
  
}
PubSub.prototype.emit  = function () {
  var eventType = Array.prototype.shift.call(arguments)
  var arr = this.obj[eventType] || [];
  for (let i = 0; i < arr.length; i++) {
    arr[i].apply(arr[i], arguments)
  }
}

PubSub.prototype.off  = function () {
  var eventType = Array.prototype.shift.call(arguments)
  this.obj[eventType] = null;
  return this;
}

window.pubsub = new PubSub();

const os = require('os').networkInterfaces()
console.log('os',os)
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');


